import { IFilTerValue } from "@shared/lib/types/globalDiscovery";

export const cleanseFilters = (val: IFilTerValue): IFilTerValue => {
  let newFilters: IFilTerValue = {};
  Object.entries(val).forEach(([key, value]) => {
    if (key === "filterTags") {
      const filterTagsVal = cleanseFilters(value);
      newFilters[key] = filterTagsVal;
    } else if (value !== undefined) {
      newFilters[key] = value;
    }
  });
  return newFilters;
};
